import React, { useEffect } from "react"
import { IMG } from "../common/CONST"
import { useStore } from "../../stores/RootStoreContext"
import * as TrinityAPI from "../../requests/TrinityAPI"
import { CONFIG } from "../../CONFIG"
import { useInstancesStore } from "@/stores/instancesStore"
import { Link } from "react-router-dom"
import {
  ADMIN_COMPANY_ROUTE,
  ADMIN_USER_ROUTE,
  BALANCE_ROUTE,
  BASE_RATES,
  CURRENCY_EXCHANGE_ROUTE,
  CURRENCY_REPLENISHMENT_ROUTE,
  DASHBOARD_ROUTE,
  ORDER_ROUTE,
  RATES_ROUTE,
  REPLENISHMENT_ROUTE,
  REQUEST_ROUTE
} from "@/routes"
import { useUnreadStore } from "@/stores/unreadStore"

export const MenuManager: React.FC<{ active: string }> = ({ active }) => {
  const { userStore } = useStore()

  const { unreadList, setUnreadList } = useUnreadStore()
  const { instancesList, setInstances } = useInstancesStore()

  if (!userStore.isManager) {
    userStore.setToken("")
    window.location.href = "/"
  }

  useEffect(() => {
    fetchUnread()

    const intervalId = setInterval(() => {
      fetchUnread()
    }, CONFIG.fetchUnreadsInterval)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  const fetchUnread = () => {
    TrinityAPI.getUnreadConversations("", response => {
      if (response.status === 200) {
        setUnreadList(response.data)
      }
    })
    TrinityAPI.getActionsRequired(response => {
      if (response.status === 200) {
        setInstances(response.data)
      }
    })
  }

  const countMsgByType = (type: string): string => {
    let count = 0
    unreadList?.items.forEach(i => {
      count += i.type === type ? i.num : 0
    })
    return count > 0 ? count.toString() : ""
  }

  const countInstanceByType = (type: string) => {
    let count = 0
    instancesList?.items.forEach(i => {
      count += i.type === type ? i.num : 0
    })
    return count > 0 ? count.toString() : ""
  }

  return (
    <header className="header">
      <Link to={DASHBOARD_ROUTE} className="logo-header">
        <img src={IMG.sign} alt="" className="logo-header-img" />
        <span>trinity</span>
      </Link>
      <nav className="header-nav">
        <ul className="header-nav-list">
          <Link className={`header-nav-item${active === "dashboard" ? "-active" : ""}`} to={DASHBOARD_ROUTE}>
            <img src={IMG.home} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Главная</div>
            <span className="span-actions">{countInstanceByType("INN")}</span>
          </Link>
          <Link className={`header-nav-item${active === "company" ? "-active" : ""}`} to={ADMIN_COMPANY_ROUTE}>
            <img src={IMG.companies} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Зарубежные компании</div>
          </Link>
          {userStore.isManagerReq && (
            <>
              <Link className={`header-nav-item${active === "request" ? "-active" : ""}`} to={REQUEST_ROUTE}>
                <img src={IMG.requests} alt="" className="header-nav-icon" />
                <div className="header-nav-title">Запросы</div>
                <span className="span-message">{countMsgByType("REQUEST")}</span>
                <span className="span-actions">{countInstanceByType("REQUEST")}</span>
              </Link>
              <Link
                className={`header-nav-item${active === "replenishment" ? "-active" : ""}`}
                to={REPLENISHMENT_ROUTE}
              >
                <img src={IMG.deals} alt="" className="header-nav-icon" />
                <div className="header-nav-title">Пополнения рублевые</div>
                <span className="span-message">{countMsgByType("REPLENISHMENT")}</span>
                <span className="span-actions">{countInstanceByType("REPLENISHMENT")}</span>
              </Link>
              <Link
                className={`header-nav-item${active === "currency-replenishment" ? "-active" : ""}`}
                to={CURRENCY_REPLENISHMENT_ROUTE}
              >
                <img src={IMG.deals} alt="" className="header-nav-icon" />
                <div className="header-nav-title">Пополнения валютные</div>
                <span className="span-message">{countMsgByType("CURREPLENISHMENT")}</span>
                <span className="span-actions">{countInstanceByType("CURREPLENISHMENT")}</span>
              </Link>
            </>
          )}
          {userStore.isManagerOrd && (
            <Link className={`header-nav-item${active === "order" ? "-active" : ""}`} to={ORDER_ROUTE}>
              <img src={IMG.orders} alt="" className="header-nav-icon" />
              <div className="header-nav-title">Ордера</div>
              <span className="span-message">{countMsgByType("ORDER")}</span>
              <span className="span-actions">{countInstanceByType("ORDER")}</span>
            </Link>
          )}
          <Link
            className={`header-nav-item${active === "client" ? "-active" : ""}`}
            to={`${ADMIN_USER_ROUTE}?role=ROLE_CLIENT`}
          >
            <img src={IMG.contr} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Пользователи</div>
          </Link>
          <Link className={`header-nav-item${active === "base-client-rates" ? "-active" : ""}`} to={BASE_RATES}>
            <img src={IMG.exchange} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Ставки платформы</div>
          </Link>
          <Link className={`header-nav-item${active === "rates" ? "-active" : ""}`} to={RATES_ROUTE}>
            <img src={IMG.exchange} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Курсы валют</div>
          </Link>
          {userStore.isManagerStmtRead && (
            <Link className={`header-nav-item${active === "balance" ? "-active" : ""}`} to={BALANCE_ROUTE}>
              <img src={IMG.money_bag} alt="" className="header-nav-icon" />
              <div className="header-nav-title">Балансы</div>
            </Link>
          )}
          <Link
            className={`header-nav-item${active === "currencyExchange" ? "-active" : ""}`}
            to={CURRENCY_EXCHANGE_ROUTE}
          >
            <img src={IMG.exchange} alt="" className="header-nav-icon" />
            <div className="header-nav-title">Обмен валют</div>
          </Link>
        </ul>
      </nav>
    </header>
  )
}
